(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar-controls')) {
    customElements.define('announcement-bar-controls', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.bar = this.querySelector('announcement-bar');
        this.slider = this.querySelector('.announcement-bar__inner--multiple');
        if (!this.slider) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-announcement-previous], [data-announcement-next]');
          if (!button || !this.swiper) return;
          const duration = this.motion.matches ? 0 : this.swiper.params.speed;
          if (button.hasAttribute('data-announcement-previous')) this.swiper.slidePrev(duration);
          else this.swiper.slideNext(duration);
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.swiper?.autoplay?.stop();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          if (!document.hidden) this.bar.applyAutoplayState?.();
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.swiper?.autoplay?.stop();
          else if (!this.matches(':hover')) this.bar.applyAutoplayState?.();
        }, { signal });
        this.motion.addEventListener('change', () => {
          if (this.swiper) this.swiper.params.speed = this.motion.matches ? 0 : this.slideDuration;
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const slide = Array.from(this.querySelectorAll('[data-announcement-block]')).find(item => item.dataset.announcementBlock === event.detail?.blockId);
          if (!slide || !this.swiper) return;
          this.editorPausedBeforeSelect ??= this.bar.manualPaused;
          this.bar.manualPaused = true;
          this.bar.applyAutoplayState?.();
          this.swiper.slideToLoop(Number(slide.dataset.announcementIndex), 0);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => {
          if (this.editorPausedBeforeSelect === undefined) return;
          this.bar.manualPaused = this.editorPausedBeforeSelect;
          this.editorPausedBeforeSelect = undefined;
          this.bar.applyAutoplayState?.();
        }, { signal });
        this.observer = new MutationObserver(() => this.bindSwiper());
        this.observer.observe(this.slider, { attributes: true, attributeFilter: ['class'] });
        this.bindSwiper();
      }
      bindSwiper() {
        if (!this.bar.swiper || this.swiper) return;
        this.swiper = this.bar.swiper;
        this.observer?.disconnect();
        this.slideDuration = this.swiper.params.speed;
        if (this.motion.matches) this.swiper.params.speed = 0;
        this.syncSlides = () => {
          this.swiper.slides.forEach(slide => {
            const active = Number(slide.dataset.announcementIndex) === this.swiper.realIndex;
            slide.inert = !active;
            slide.setAttribute('aria-hidden', String(!active));
          });
        };
        this.swiper.on('slideChange', this.syncSlides);
        this.swiper.on('loopFix', this.syncSlides);
        this.syncSlides();
        this.querySelectorAll('[data-announcement-previous], [data-announcement-next]').forEach(button => { button.hidden = false; });
        if (document.hidden) this.swiper.autoplay?.stop();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.swiper?.off('slideChange', this.syncSlides);
        this.swiper?.off('loopFix', this.syncSlides);
        this.swiper = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('modish-collection-rail')) {
  customElements.define('modish-collection-rail', class extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector('.ad-grid');
      const card = container?.querySelector('.ad-card');
      if (!container || !card) return;
      this.events = new AbortController();
      const { signal } = this.events;
      const step = direction => {
        const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
        container.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.querySelector('.next')?.addEventListener('click', () => step(1), { signal });
      this.querySelector('.prev')?.addEventListener('click', () => step(-1), { signal });
      container.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, { signal });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('modish-hero-motion')) {
  customElements.define('modish-hero-motion', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;
      this.events = new AbortController();
      const { signal } = this.events;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      let visible = false;
      const syncButton = () => video.setAttribute('aria-pressed', String(!video.paused));
      const maybePlay = () => {
        if (visible && !document.hidden && !reduced.matches && !navigator.connection?.saveData && !userPaused) {
          video.play().catch(syncButton);
        } else {
          video.pause();
        }
      };
      video.controls = false;
      video.muted = true;
      video.playsInline = true;
      video.tabIndex = 0;
      video.setAttribute('role', 'button');
      video.setAttribute('aria-label', this.dataset.playLabel);
      video.addEventListener('play', syncButton, { signal });
      video.addEventListener('pause', syncButton, { signal });
      const toggle = () => {
        userPaused = !video.paused;
        if (video.paused) video.play().catch(syncButton);
        else video.pause();
      };
      video.addEventListener('click', toggle, { signal });
      video.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      }, { signal });
      reduced.addEventListener('change', maybePlay, { signal });
      document.addEventListener('visibilitychange', maybePlay, { signal });
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        maybePlay();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      syncButton();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modish-department-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('modish-department-rail')) {
  customElements.define('modish-department-rail', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      const grid = this.querySelector('.md-dept__grid');
      const cards = [...this.querySelectorAll('.md-dept__tile')];
      const previous = this.querySelector('[data-md-previous]');
      const next = this.querySelector('[data-md-next]');
      const controls = this.querySelector('[data-md-controls]');
      if (!grid || !cards.length || !previous || !next) return;
      this.events = new AbortController();
      const {signal} = this.events;
      const update = () => {
        const limit = grid.scrollWidth - grid.clientWidth;
        previous.hidden = next.hidden = limit < 2;
        if (controls) controls.hidden = limit < 2;
        previous.setAttribute('aria-disabled', String(grid.scrollLeft < 2));
        next.setAttribute('aria-disabled', String(grid.scrollLeft >= limit - 2));
      };
      const step = direction => {
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        grid.scrollBy({left:direction * (cards[0].getBoundingClientRect().width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => {if(previous.getAttribute('aria-disabled') !== 'true') step(-1);}, {signal});
      next.addEventListener('click', () => {if(next.getAttribute('aria-disabled') !== 'true') step(1);}, {signal});
      grid.addEventListener('scroll', update, {passive:true,signal});
      grid.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const index = cards.indexOf(event.target.closest('.md-dept__tile'));
        if (index < 0) return;
        event.preventDefault();
        cards[Math.max(0, Math.min(cards.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)))].focus();
      }, {signal});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(grid);
      this.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('.md-dept__tile');
        if (selected) grid.scrollTo({left:selected.offsetLeft,behavior:'instant'});
      }, {signal});
      update();
    }
    disconnectedCallback() {this.events?.abort();this.resizeObserver?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modish-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('modish-header')) {
    customElements.define('modish-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.drawer = this.querySelector('.mh-drawer');
        this.toggleButton = this.querySelector('[data-mh-open]');
        this.desktop = this.querySelector('.mh-nav--desktop');
        this.addEventListener('click', event => {
          const summary = event.target.closest('.mh-nav--desktop summary');
          if (summary) clearTimeout(this.hoverTimer);
          if (event.target.closest('.search-drawer_popup,.cart_sidebar_open_btn')) this.closeMenus();
          if (event.target.closest('[data-mh-open]')) this.openDrawer();
          if (event.target.closest('[data-mh-close]')) this.closeDrawer();
          if (event.target.closest('[data-mh-dismiss]')) this.closeMenus();
          if (event.target === this.drawer) {
            const rect = this.drawer.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDrawer();
          }
        }, { signal });
        this.drawer.addEventListener('close', () => {
          document.documentElement.classList.remove('mh-menu-open');
          this.toggleButton.setAttribute('aria-expanded', 'false');
        }, { signal });
        this.querySelectorAll('details').forEach(details => {
          details.addEventListener('toggle', () => {
            const summary = details.querySelector(':scope > summary');
            summary?.setAttribute('aria-expanded', String(details.open));
            if (!details.open) return;
            this.querySelectorAll('details[open]').forEach(other => {
              if (other !== details && !other.contains(details) && !details.contains(other)) other.open = false;
            });
            this.measure();
          }, { signal });
        });
        this.addEventListener('keydown', event => {
          const details = event.target.closest('details');
          if (event.key === 'Escape' && details?.open) {
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.hoverTimer);
            details.open = false;
            details.querySelector(':scope > summary')?.focus({ preventScroll: true });
          }
          if (event.key === 'ArrowDown' && (event.target.matches('summary') || event.target.matches('.mh-category-link'))) {
            event.preventDefault();
            const target = details || event.target.parentElement.querySelector('details');
            if (!target) return;
            clearTimeout(this.hoverTimer);
            target.open = true;
            requestAnimationFrame(() => target.querySelector('.mh-panel a[href],.mh-panel button,.mh-language-panel button')?.focus({ preventScroll: true }));
          }
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closeMenus();
        }, { signal });
        this.desktop.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.desktop.contains(document.activeElement)) this.desktop.querySelectorAll('details[open]').forEach(item => { item.open = false; });
          });
        }, { signal });
        this.querySelectorAll('.mh-language').forEach(language => {
          language.addEventListener('focusout', () => {
            requestAnimationFrame(() => { if (!language.contains(document.activeElement)) language.open = false; });
          }, { signal });
        });
        if (this.dataset.hover === 'true') {
          this.desktop.querySelectorAll('[data-mh-dropdown]').forEach(details => {
            const item = details.closest('.mh-nav-item');
            item.addEventListener('pointerenter', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(this.hoverTimer);
              this.hoverTimer = setTimeout(() => {
                if (!details.open) {
                  details.open = true;
                }
              }, 140);
            }, { signal });
            item.addEventListener('pointerleave', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(this.hoverTimer);
              this.hoverTimer = setTimeout(() => {
                if (!item.contains(document.activeElement)) {
                  details.open = false;
                }
              }, 220);
            }, { signal });
          });
        }
        this.measure = this.measure.bind(this);
        this.resize = new ResizeObserver(this.measure);
        this.resize.observe(this);
        window.addEventListener('resize', this.measure, { passive: true, signal });
        window.addEventListener('scroll', this.measure, { passive: true, signal });
        document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
        document.addEventListener('shopify:block:select', event => {
          const block = this.querySelector(`[data-shopify-editor-block*='${event.detail.blockId}']`);
          const position = block?.closest('[data-menu-position]')?.dataset.menuPosition;
          if (!position) return;
          const compact = innerWidth < 1024 || this.classList.contains('is-compact');
          if (compact) this.openDrawer();
          const scope = compact ? this.drawer : this.desktop;
          const details = scope.querySelector(`[data-menu-position='${position}']`);
          if (details) details.open = true;
        }, { signal });
        this.measure();
      }
      measure() {
        const rect = this.getBoundingClientRect();
        this.style.setProperty('--mh-bottom', Math.max(0, rect.bottom) + 'px');
        document.documentElement.style.setProperty('--header-height', this.dataset.sticky === 'true' ? rect.height + 'px' : '0px');
        const list = this.desktop.querySelector('.mh-nav-list');
        if (innerWidth >= 1024 && list.getBoundingClientRect().width) {
          const items = [...list.children];
          const gap = parseFloat(getComputedStyle(list).gap) || 0;
          this.requiredWidth = items.reduce((sum, item) => sum + item.getBoundingClientRect().width, 0) + gap * Math.max(0, items.length - 1);
        }
        const pad = parseFloat(getComputedStyle(this).getPropertyValue('--mh-pad')) || 24;
        const width = parseFloat(getComputedStyle(this).getPropertyValue('--mh-width')) || this.clientWidth;
        const compact = innerWidth >= 1024 && this.requiredWidth > Math.min(this.clientWidth, width) - pad * 2;
        this.classList.toggle('is-compact', compact);
        if (innerWidth >= 1024 && !compact && this.drawer.open) this.closeDrawer(false);
      }
      closeMenus() {
        clearTimeout(this.hoverTimer);
        this.querySelectorAll('.mh-nav--desktop details[open],.mh-language[open]').forEach(details => {
          details.open = false;
        });
      }
      openDrawer() {
        this.closeMenus();
        if (!this.drawer.open) this.drawer.showModal();
        document.documentElement.classList.add('mh-menu-open');
        this.toggleButton.setAttribute('aria-expanded', 'true');
      }
      closeDrawer(restoreFocus = true) {
        this.drawer.close();
        if (restoreFocus) this.toggleButton.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        clearTimeout(this.hoverTimer);
        document.documentElement.classList.remove('mh-menu-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modish-shop-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('modish-shop-edit')) {
    customElements.define(
      'modish-shop-edit',
      class ModishShopEdit extends HTMLElement {
        connectedCallback() {
          if (this.abortController) this.abortController.abort();
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[data-panel-index]'));

          if (this.tabs.length < 2 || this.tabs.length !== this.panels.length) return;

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activate(index), { signal });
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
          });

          document.addEventListener(
            'shopify:block:select',
            (event) => this.onBlockSelect(event),
            { signal }
          );

          this.activate(0);
          this.dataset.tabsReady = 'true';
        }

        disconnectedCallback() {
          if (this.abortController) this.abortController.abort();
        }

        activate(index, moveFocus = false) {
          if (!this.tabs[index] || !this.panels[index]) return;

          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            this.panels[tabIndex].hidden = !active;
          });

          if (moveFocus) this.tabs[index].focus();
        }

        onKeydown(event, currentIndex) {
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = this.tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          this.activate(nextIndex, true);
        }

        onBlockSelect(event) {
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;

          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === String(blockId));
          if (index >= 0) this.activate(index);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
